import React, { useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import List from "@mui/material/List";
import { useLocation } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import MenuIcon from "@mui/icons-material/Menu";
import { useTranslation } from "react-i18next";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import "../assets/css/SideBar.css";
import { NavLink } from "react-router-dom";
import ViewListIcon from "@mui/icons-material/ViewList";
import { Toolbar, IconButton, Box, Menu, MenuItem } from "@mui/material";
import LoginPc from "../assets/images/computer.png";
import LogoutIcon from "@mui/icons-material/Logout";
import LogoutModal from "./LogOutModal";
import TranslateIcon from "@mui/icons-material/Translate";
const drawerWidth = 260;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open, i18n }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: i18n.language === "ar" ? `0` : `${drawerWidth}px`, // إذا كانت اللغة عربية، marginLeft يكون 0، إذا كانت إنجليزية، يكون drawerWidth
    marginRight: i18n.language === "ar" ? `${drawerWidth}px` : `0`,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  variants: [
    {
      props: ({ open }) => open,
      style: {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": openedMixin(theme),
      },
    },
    {
      props: ({ open }) => !open,
      style: {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": closedMixin(theme),
      },
    },
  ],
}));

export default function SideBar() {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [logoutDialog, setLogoutDialog] = useState(false);
  const location = useLocation();

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleOpenLogoutDialog = () => {
    setLogoutDialog(true);
  };

  const handleCloseLogoutDialog = () => {
    setLogoutDialog(false);
  };

  const handleLogout = () => {
    console.log("User logged out");
    setLogoutDialog(false);
  };

  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    handleCloseMenu();
  };
  const isRtl = i18n.language === "ar";
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        open={open}
        i18n={i18n}
        sx={{ backgroundColor: "#db2121ff" }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={[
              {
                marginRight: i18n.language === "ar" ? 0 : 5,
                marginLeft: i18n.language === "ar" ? 5 : 0,
              },
              open && { display: "none" },
            ]}
          >
            <MenuIcon />
          </IconButton>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#fff",
              padding: "6px",
              borderRadius: "4px",
            }}
          >
            <img
              src={LoginPc}
              alt="Logo"
              style={{ height: "40px", width: "auto" }}
            />
          </Box>

          <Box sx={{ flexGrow: 1 }} />

          <IconButton
            color="inherit"
            aria-label="translate"
            onClick={handleOpenMenu}
          >
            <TranslateIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleCloseMenu}
          >
            <MenuItem onClick={() => handleLanguageChange("en")}>
              English
            </MenuItem>
            <MenuItem onClick={() => handleLanguageChange("ar")}>عربي</MenuItem>
          </Menu>

          <IconButton
            color="inherit"
            aria-label="logout"
            onClick={handleOpenLogoutDialog}
          >
            <LogoutIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer variant="permanent" open={open} anchor={isRtl ? "right" : "left"}>
        <DrawerHeader>
          <IconButton
            onClick={handleDrawerClose}
            sx={{ backgroundColor: "#db2121ff", color: "white" }}
          >
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />

        <List>
          <ListItem disablePadding>
            <ListItemButton
              component={NavLink}
              to="/shipment-not-collected"
              onClick={handleDrawerClose}
            >
              <ListItemIcon>
                <ViewListIcon sx={{ color: "#db2121ff" }} />
              </ListItemIcon>
              <ListItemText sx={{ color: "#db2121ff" }}>
                {t("allUser")}
              </ListItemText>
            </ListItemButton>
          </ListItem>
        </List>

        <Divider />
      </Drawer>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          backgroundColor: "white",
          padding: "0",
        }}
      ></Box>
      <LogoutModal
        open={logoutDialog}
        handleClose={handleCloseLogoutDialog}
        handleLogout={handleLogout}
      />
    </Box>
  );
}
